import { ojs } from "modular-openscriptjs";
import { Analytics } from "./Analytics";
import { Auth } from "./Auth";
import { Capa } from "./Capa";
import ErrandMediator from "./ErrandMediator";
import HashtagLocationMediator from "./HashtagLocationMediator";
import { LocationMediator } from "./Location";
import OrderMediator from "./OrderMediator";
import { Payment } from "./Payment";
import PaymentRequest from "./PaymentRequest";
import Purchase from "./Purchase";
import { QRCode } from "./QRCode";
import { Review } from "./Review";
import { Setting } from "./Setting";
import Surplus from "./Surplus";
import System from "./System";
import { User } from "./User";
import CapaPayment from "./PaymentMethods/CapaPayment";
import MpesaPayment from "./PaymentMethods/MpesaPayment";
import OfflineMpesaPayment from "./PaymentMethods/OfflineMpesaPayment";

ojs(
	Analytics,
	Auth,
	Capa,
	ErrandMediator,
	HashtagLocationMediator,
	LocationMediator,
	OrderMediator,
	Payment,
	PaymentRequest,
	Purchase,
	QRCode,
	Review,
	Setting,
	Surplus,
	System,
	User,
	CapaPayment,
	MpesaPayment,
	OfflineMpesaPayment,
);
